import './index.scss';

import { Component, ReactNode } from 'react';

import { UncontrolledField } from '..';
import { BraxButton } from '../../BraxButton';
import { BraxIcon } from '../../BraxIcon';

export type BraxNPSValue = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export const braxNPSValue: BraxNPSValue[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

export type BraxUncontrolledNPSFieldProps = Omit<UncontrolledField<BraxNPSValue>, 'id' | 'name'> & {
    label?: ReactNode,
    hint?: ReactNode,
    required?: boolean,
    onChange?: (value: BraxNPSValue) => void
};

type BraxUncontrolledNPSFieldState = {
    show: boolean
};

export class BraxUncontrolledNPSField extends Component<BraxUncontrolledNPSFieldProps, BraxUncontrolledNPSFieldState> {

    static defaultProps = {
        disabled: false,
        status: null
    };

    state = {
        show: false
    };

    change(value: BraxNPSValue) {
        if (this.props.onChange)
            this.props.onChange(value);
    }

    render() {
        return (
            <div className={`brax-nps-field ${this.props.status}`}>
                { this.props.label ? (
                    <label>{ this.props.label } { this.props.required ? '*' : null }</label>
                ) : null }

                <div>
                    { braxNPSValue.map(value => (
                        <BraxButton
                            key={value}
                            className={value === this.props.value ? 'selected' : ''}
                            variant="secondary"
                            disabled={this.props.disabled}
                            onClick={() => this.change(value)}
                        >
                            { value < 10 ? '0' : '' }{ value }
                        </BraxButton>
                    )) }

                    <div className="brax-nps-divider" />
                </div>

                { this.props.hint ? (
                    <p className="hint">
                        { this.props.status === 'error' ? <BraxIcon icon="exclamation-mark" /> : null }

                        <span>{ this.props.hint }</span>
                    </p>
                ) : null }
            </div>
        );
    }

}
